import { render } from "./ServerError.vue?vue&type=template&id=6f910952&scoped=true"
const script = {}

import "./ServerError.vue?vue&type=style&index=0&id=6f910952&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f910952"]])

export default __exports__